import { CartLine, PickupTimeOption } from '../types';

/**
 * Returns product IDs that should be removed from cart when changing to a new staging.
 * Products are removed if they have staging restrictions and the new staging isn't in their list.
 */
export const getProductsToRemove = (
    cartLines: CartLine[],
    newStagingId: number,
): number[] => {
    return cartLines
        .filter(
            line =>
                line.product.stagings.length !== 0 &&
                !line.product.stagings.includes(newStagingId),
        )
        .map(line => line.product.id);
};

/**
 * Checks if the cart contains any restaurant-only products.
 */
export const hasRestaurantProduct = (cartLines: CartLine[]): boolean => {
    return cartLines.some(line => line.product.is_restaurant_only);
};

/**
 * Determines if the order type should be reset when changing shows.
 * Returns true if the current order type is not available in the new show's pickup times.
 */
export const shouldResetOrderType = (
    currentOrderType: number | null,
    newShowPickupTimes: PickupTimeOption[] | undefined,
): boolean => {
    if (!currentOrderType) {
        return false;
    }

    if (!newShowPickupTimes || newShowPickupTimes.length === 0) {
        return false;
    }

    return !newShowPickupTimes.some(opt => opt.value === currentOrderType);
};
